import { __generator } from "tslib";
import { call, put, takeEvery } from 'redux-saga/effects';
import { initialize, submit, submitFailure, submitSuccess, requestFailure, requestSuccess, } from './actionCreators';
import fakeData from './fake';
import { request } from '../../xhr';
function getFakeData() {
    if (process.env.NODE_ENV !== 'production') {
        return fakeData;
    }
    return false;
}
function handleInitialize(action) {
    var deviationId, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                deviationId = action.payload.deviationId;
                return [4 /*yield*/, call(request, {
                        method: 'get',
                        url: 'deviation/report/init',
                        params: {
                            deviationid: deviationId,
                        },
                    }, getFakeData)];
            case 1:
                result = _a.sent();
                if (!result) return [3 /*break*/, 3];
                return [4 /*yield*/, put(requestSuccess(deviationId, result))];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, put(requestFailure(deviationId))];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [2 /*return*/];
        }
    });
}
function handleSubmit(action) {
    var _a, typeid, deviationId, answers, result;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, typeid = _a.typeid, deviationId = _a.deviationId, answers = _a.answers;
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: 'deviation/report/save',
                        data: {
                            typeid: typeid,
                            deviationid: deviationId,
                            answers: JSON.stringify(answers),
                        },
                    }, getFakeData)];
            case 1:
                result = _b.sent();
                if (!result) return [3 /*break*/, 3];
                // TODO: replace with system message (toast)
                alert('Report submitted successfully');
                return [4 /*yield*/, put(submitSuccess())];
            case 2:
                _b.sent();
                return [3 /*break*/, 5];
            case 3:
                alert('Failed to submit report. Please try again.');
                return [4 /*yield*/, put(submitFailure())];
            case 4:
                _b.sent();
                _b.label = 5;
            case 5: return [2 /*return*/];
        }
    });
}
export default function ReportPageModalRootSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeEvery(initialize, handleInitialize)];
            case 1:
                _a.sent();
                return [4 /*yield*/, takeEvery(submit, handleSubmit)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map